import React from 'react';

export default function internalImage(props) {
    const {id} = props;
    if (id) {
        return (
            <img src={`${window.CARE_CONFIG.image_storage_base_url}${id}`}></img>
        )
    }
    return null;
}



// WEBPACK FOOTER //
// ./src/js/components/internal-image.js